import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import ADIProductAvailability from "@NA/Components/RecentlyPurchasedProduct/ADIProductAvailability";
import ADIProductDeliveryInfo from "@NA/Components/RecentlyPurchasedProduct/ADIProductDeliveryInfo";
import ADIProductImage from "@NA/Components/RecentlyPurchasedProduct/ADIProductImage";
import ProductPrice, { ProductPriceStyles } from "@NA/Overrides/Components/ProductPrice";
import ADIColors from "@NA/Utils/ADIColors";
import ProductComapreCheckbox, {
    ProductComapreCheckboxStyles,
} from "@NA/Widgets/ProductCompare/ProductCompareCheckbox";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import ADIProductAddToCartButton from "./ADIProductAddToCartButton";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ADIProductDescription from "../RecentlyPurchasedProduct/ADIProductDescription";
import ADIProductPartNumbers, { ADIProductPartNumbersStyles } from "../RecentlyPurchasedProduct/ADIProductPartNumbers";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import siteMessage from "@insite/client-framework/SiteMessage";
import CrossIcon from "@NA/Icons/CrossIcon";
import { pushDealerAuthDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productCarouselProductStyles } from "@NA/Components/ProductDetail/ADIProductCarouselStyles";
import ADIProductSaleInfo from "../ProductList/ADIProductSaleInfo";
import { getMaxProductHeight } from "@NA/Utils/Utility";
import loadBundledProducts from "@NA/Handlers/ADILoadBundledProductsDataHandler";

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    const session = getSession(state);
    let customerNumber = "";
    const billToId = session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        productSettings: getSettingsCollection(state).productSettings,
        session,
        settingsCollection: getSettingsCollection(state),
        showADIAddToCart: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        customerNumber,
        isAuthenticated: state.context.session.isAuthenticated,
    };
};

const mapDispatchToProps = {
    updateProductInfo,
    toggleLoginDrawer,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    showImage: boolean;
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    extendedStyles?: ProductCarouselProductStyles;
    view: string;
    showAvailability: boolean;
    productInfo: ProductInfo;
    sourceName: string;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ProductCarouselProductStyles {
    productImageStyles?: ProductImageStyles;
    productBrandWrapper?: InjectableCss;
    productDescriptionContainer?: InjectableCss;
    productPartNumbersContainer?: InjectableCss;
    imageWrapper?: InjectableCss;
    mobLeftSideContainer?: InjectableCss;
    mobProdPartNumbers?: InjectableCss;
    mainContainer?: InjectableCss;
    mobRightSideContainer?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ADIProductPartNumbersStyles;
    productPriceWrapper?: InjectableCss;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: InjectableCss;
    addToCartContainerWithoutSignIn?: InjectableCss;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: InjectableCss;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    availabilityGridItem?: InjectableCss;
    availabilityStyles?: ProductAvailabilityStyles;
    productComapreCheckboxStyles?: ProductComapreCheckboxStyles;
    productPriceStyles?: ProductPriceStyles;
    signInDealerPrice?: InjectableCss;
    dealerPriceText?: TypographyProps;
    dealerCertificationModal?: ModalPresentationProps;
    showAuthContainer?: InjectableCss;
    showDesktopAuthContainer?: InjectableCss;
    showAuthInnerContainer?: InjectableCss;
    stylesdealerTitle?: InjectableCss;
    getCertifiedText?: InjectableCss;
    isPendingVerificationSignIn?: InjectableCss;
}
export const ProductCarouselProductStyles: ProductCarouselProductStyles = {
    productPriceStyles: {
        price: {
            priceText: {
                weight: "bold",
                css: css`
                    color: ${ADIColors.darkBlue4};
                    display: flex;
                    flex-wrap: wrap;
                    .symbolText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-right: 2px;
                        position: relative;
                        top: 0px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    font-size: 12px;
                                `,
                                css`
                                    font-size: 12px;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                    .priceText {
                        font-size: 30px;
                        font-weight: 900;
                        line-height: 1.1;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    font-size: 20px;
                                `,
                                css`
                                    font-size: 20px;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                    .currencyText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-left: 2px;
                        position: relative;
                        top: -2px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    font-size: 12px;
                                    top: -1px;
                                `,
                                css`
                                    font-size: 12px;
                                    top: -1px;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                    .unitofmeasureText {
                        font-size: 12px !important;
                        position: relative;
                        font-weight: 600;
                        color: #666;
                        display: block !important;
                    }
                `,
            },
        },
    },
    isPendingVerificationSignIn: {
        css: css`
            flex-grow: 0;
            padding-top: 35px;
            margin: 20px;
            cursor: auto;
            > div:hover {
                background-color: transparent;
                span {
                    color: ${ADIColors.darkBlue1};
                }
            }
            span {
                color: ${ADIColors.darkBlue1};
            }
        `,
    },
};
const ADIProductCarouselProduct: React.FC<Props> = ({
    carouselId,
    product,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice,
    showAddToCart,
    updateProductInfo,
    extendedStyles,
    view,
    productInfo,
    session,
    toggleLoginDrawer,
    showADIAddToCart,
    sourceName,
    customerNumber,
    isAuthenticated,
}) => {
    const [styles] = React.useState(() => mergeToNew(productCarouselProductStyles, extendedStyles));
    const [dealerModalIsOpen, setDealerModalIsOpen] = React.useState(false);
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    if (!product || !productInfo) {
        return null;
    }
    const openSignIn = () => {
        toggleLoginDrawer({
            loginDrawer: true,
        });
    };

    const getCertified = () => {
        setDealerModalIsOpen(true);
    };

    const dealerModalCloseHandler = () => {
        setDealerModalIsOpen(false);
    };

    const freeShippingAmount = Number(session.properties.freeshipThresholdAmt);
    const pricing = productInfo?.pricing || product.pricing;

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };

    const showAuthorizationRequired =
        pricing &&
        pricing.additionalResults &&
        pricing.additionalResults.isVisible &&
        pricing.additionalResults.isVisible === "N"
            ? "true"
            : "false";
    const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList?.toLowerCase();
    const brandName = product.brand?.name ?? "";
    const vendorAuthRequiredLink = product?.properties?.vendorAuthRequiredLink;

    const clickHandler = () => {
        pushDealerAuthDataToDataLayer(brandName, vendorAuthRequiredLink, customerNumber, sourceName, session);
    };
    const [minDescHeight, setMinDescHeight] = useState(15);
    const [minPartHeight, setMinPartHeight] = useState(14);
    const [minPriceHeight, setMinPriceHeight] = useState(40);
    const [minStockAvailHeight, setMinStockAvailHeight] = useState(10);
    useEffect(() => {
        const maxDescHeight = getMaxProductHeight('[data-test-selector="productDescriptionLink"]');
        const maxPartHeight = getMaxProductHeight('[data-test-selector="plpPartNumber"]');
        const maxPriceHeight = getMaxProductHeight('[data-test-selector="recommendeProductPrice"]');
        const maxStockAvailHeight = getMaxProductHeight('[data-test-selector="recommendedStockAvailable"]');
        setMinDescHeight(maxDescHeight);
        setMinPartHeight(maxPartHeight);
        setMinPriceHeight(maxPriceHeight);
        setMinStockAvailHeight(maxStockAvailHeight);
        const bundleProductErpNumber = product.properties.bundleProductErpNumber?.split(",");
        let totalProductAmount = productInfo.pricing?.unitNetPrice ? productInfo.pricing?.unitNetPrice : 0;
        let checkedItems: string[] = [];
        checkedItems.push(product.id);
        loadBundledProducts({
            productNumbers: bundleProductErpNumber ?? [],
            expand: "properties",
            onSuccess(result: any) {
                // const productInfosByProductIdKey = Object.keys(result.productInfosByProductId);
                // if (productInfosByProductIdKey) {
                //     productInfosByProductIdKey.map(item => {
                //         const price = result.productInfosByProductId[item].pricing?.unitNetPrice;
                //         if (price) {
                //             totalProductAmount += price;
                //         }
                //         checkedItems.push(item);
                //     });
                // }
            },
            onComplete(result: any) {},
        });
    }, []);

    return (
        <>
            <ProductContext.Provider value={productContext} {...styles.mainContainer}>
                {isAuthenticated ? (
                    <ADIProductSaleInfo product={product} isAuthenticated={true} pricing={pricing} />
                ) : (
                    <ADIProductSaleInfo product={product} isAuthenticated={false} pricing={pricing} />
                )}
                {/* {
                    !loadBundledProducts.length ? */}
                <>
                    <StyledWrapper {...styles.mobLeftSideContainer}>
                        <ProductComapreCheckbox extendedStyles={styles.productComapreCheckboxStyles} />
                        <StyledWrapper {...styles.imageWrapper}>
                            <ADIProductImage product={product} sourceName={sourceName} />
                            <StyledWrapper {...styles.mobProdPartNumbers}>
                                <ADIProductPartNumbers product={product} view="Grid" />
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>

                    <StyledWrapper {...styles.mobRightSideContainer}>
                        {showBrand && product.brand && (
                            <StyledWrapper {...styles.productBrandWrapper}>
                                <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                            </StyledWrapper>
                        )}
                        {showTitle && (
                            <StyledWrapper
                                {...styles.productDescriptionContainer}
                                style={{ minHeight: minDescHeight + "px" }}
                            >
                                <>
                                    <ADIProductDescription
                                        session={session}
                                        sourceName="Recommended"
                                        product={product}
                                        extendedStyles={styles.productDescriptionStyles}
                                    />
                                </>
                            </StyledWrapper>
                        )}
                        {showPartNumbers && (
                            <StyledWrapper
                                {...styles.productPartNumbersContainer}
                                data-test-selector="plpPartNumber"
                                style={{ minHeight: minPartHeight + "px" }}
                            >
                                <ADIProductPartNumbers
                                    product={product}
                                    view="Grid"
                                    extendedStyles={styles.productPartNumbersStyles}
                                />
                            </StyledWrapper>
                        )}
                        {showAuthorizationRequired !== "true" && (
                            <>
                                {showPrice && session.isAuthenticated && (
                                    <StyledWrapper {...styles.productPriceWrapper}>
                                        <VisuallyHidden
                                            as="label"
                                            htmlFor={`${carouselId}-uom`}
                                            id={`${carouselId}-uom-label`}
                                        >
                                            {translate("U/M")}
                                        </VisuallyHidden>
                                        <StyledWrapper
                                            style={{ minHeight: minPriceHeight + "px" }}
                                            data-test-selector="recommendeProductPrice"
                                        >
                                            <ProductPrice
                                                showLabel={false}
                                                product={productContext}
                                                extendedStyles={styles.productPriceStyles}
                                            />
                                        </StyledWrapper>
                                        <ADIProductDeliveryInfo
                                            product={product}
                                            freeShippingAmount={freeShippingAmount}
                                            showAuthorizationRequired={showAuthorizationRequired}
                                        />
                                        <ProductQuantityBreakPricing
                                            extendedStyles={styles.productQuantityBreakPricingStyles}
                                        />
                                    </StyledWrapper>
                                )}
                            </>
                        )}
                        {session.isAuthenticated && (
                            <StyledWrapper
                                {...styles.availabilityGridItem}
                                style={{ minHeight: minStockAvailHeight + "px" }}
                                data-test-selector="recommendedStockAvailable"
                            >
                                <ADIProductAvailability
                                    product={product}
                                    view={view}
                                    showAuthorizationRequired={showAuthorizationRequired}
                                />
                            </StyledWrapper>
                        )}

                        {session.isAuthenticated &&
                        !isPendingVerification &&
                        showAuthorizationRequired === "true" &&
                        vendorAuthRequiredList === "false" ? (
                            <StyledWrapper {...styles.showAuthContainer}>
                                <StyledWrapper {...styles.showAuthInnerContainer}>
                                    <StyledWrapper {...styles.stylesdealerTitle}>
                                        Dealer Certification Required
                                    </StyledWrapper>
                                    <Link {...styles.getCertifiedText} onClick={getCertified}>
                                        Get Certified
                                    </Link>

                                    <Modal
                                        {...styles.dealerCertificationModal}
                                        headline={translate("Dealer Certification Required")}
                                        isOpen={dealerModalIsOpen}
                                        handleClose={dealerModalCloseHandler}
                                    >
                                        {siteMessage("Dealer_Certification_Message")}
                                        <Button onClick={dealerModalCloseHandler}>Continue Shopping</Button>
                                    </Modal>
                                </StyledWrapper>
                            </StyledWrapper>
                        ) : session.isAuthenticated &&
                          showAuthorizationRequired === "true" &&
                          !isPendingVerification &&
                          vendorAuthRequiredList === "true" ? (
                            <StyledWrapper {...styles.showAuthContainer}>
                                <StyledWrapper {...styles.showAuthInnerContainer}>
                                    <StyledWrapper {...styles.stylesdealerTitle}>
                                        Dealer Certification Required
                                    </StyledWrapper>
                                    <Link {...styles.getCertifiedText} onClick={getCertified}>
                                        Get Certified
                                    </Link>

                                    <Modal
                                        {...styles.dealerCertificationModal}
                                        headline={translate("Dealer Certification Required")}
                                        isOpen={dealerModalIsOpen}
                                        handleClose={dealerModalCloseHandler}
                                    >
                                        {siteMessage("Dealer_Vendor_Certification_Message")}
                                        <Link
                                            href={product.properties?.vendorAuthRequiredLink}
                                            target="_blank"
                                            onClick={clickHandler}
                                        >
                                            {" "}
                                            {translate("vendor's form.")}
                                        </Link>{" "}
                                        {translate("For more information, call ")}
                                        <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                        <Button onClick={dealerModalCloseHandler}>Continue Shopping</Button>
                                    </Modal>
                                </StyledWrapper>
                            </StyledWrapper>
                        ) : (
                            <>
                                {showAddToCart &&
                                    session.isAuthenticated &&
                                    showADIAddToCart &&
                                    !isPendingVerification && (
                                        <StyledWrapper {...styles.addToCartContainer}>
                                            <StyledWrapper {...styles.addToCartButtonGridItem}>
                                                <ADIProductAddToCartButton
                                                    sourceName={sourceName}
                                                    productLine={product}
                                                    buttonLabel="Add To Cart"
                                                />
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    )}
                                {session.isAuthenticated && isPendingVerification && (
                                    <StyledWrapper
                                        {...styles.addToCartContainerWithoutSignIn}
                                        data-test-selector="signInDealer"
                                    >
                                        <StyledWrapper {...styles.isPendingVerificationSignIn}>
                                            <Typography {...styles.dealerPriceText} as="span">
                                                {translate("Account Pending Verification")}
                                            </Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}
                            </>
                        )}

                        {!session.isAuthenticated && (
                            <StyledWrapper {...styles.addToCartContainerWithoutSignIn}>
                                <StyledWrapper {...styles.signInDealerPrice} onClick={openSignIn}>
                                    <Typography {...styles.dealerPriceText} as={"span"}>
                                        {translate("Sign In for Dealer Pricing")}
                                    </Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </>
                {/* :
                        ""
                } */}
                {session.isAuthenticated &&
                showAuthorizationRequired === "true" &&
                !isPendingVerification &&
                vendorAuthRequiredList === "false" ? (
                    <StyledWrapper {...styles.showDesktopAuthContainer}>
                        <StyledWrapper {...styles.showAuthInnerContainer}>
                            <StyledWrapper {...styles.stylesdealerTitle}>Dealer Certification Required</StyledWrapper>
                            <Link {...styles.getCertifiedText} onClick={getCertified}>
                                Get Certified
                            </Link>

                            <Modal
                                {...styles.dealerCertificationModal}
                                headline={translate("Dealer Certification Required")}
                                isOpen={dealerModalIsOpen}
                                handleClose={dealerModalCloseHandler}
                            >
                                <StyledWrapper {...styles.dealerMsg}>
                                    {siteMessage("Dealer_Certification_Message")}
                                </StyledWrapper>
                                <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                    Continue Shopping
                                </Button>
                            </Modal>
                        </StyledWrapper>
                    </StyledWrapper>
                ) : session.isAuthenticated &&
                  showAuthorizationRequired === "true" &&
                  !isPendingVerification &&
                  vendorAuthRequiredList === "true" ? (
                    <StyledWrapper {...styles.showDesktopAuthContainer}>
                        <StyledWrapper {...styles.showAuthInnerContainer}>
                            <StyledWrapper {...styles.stylesdealerTitle}>Dealer Certification Required</StyledWrapper>
                            <Link {...styles.getCertifiedText} onClick={getCertified}>
                                Get Certified
                            </Link>

                            <Modal
                                {...styles.dealerCertificationModal}
                                headline={translate("Dealer Certification Required")}
                                isOpen={dealerModalIsOpen}
                                handleClose={dealerModalCloseHandler}
                            >
                                <StyledWrapper {...styles.dealerMsg}>
                                    {siteMessage("Dealer_Vendor_Certification_Message")}
                                    <Link
                                        href={product.properties?.vendorAuthRequiredLink}
                                        target="_blank"
                                        onClick={clickHandler}
                                        {...styles.vendorLink}
                                    >
                                        {" "}
                                        {translate(" vendor's form.")}
                                    </Link>{" "}
                                    {translate("For more information, call ")}
                                    <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                </StyledWrapper>
                                <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                    Continue Shopping
                                </Button>
                            </Modal>
                        </StyledWrapper>
                    </StyledWrapper>
                ) : null}
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ADIProductCarouselProduct);
